import { useQuery } from '@tanstack/react-query';

type LastReviewDateResponse = {
  lastReviewDate?: string;
};

export const useLastReviewDate = (clientId?: string) => {
  const { data, isLoading, isError, refetch } = useQuery<LastReviewDateResponse>({
    queryKey: ['clients', clientId, 'suitability-reports', 'last-review-date'],
    enabled: !!clientId,
  });

  const lastReviewDate = data?.lastReviewDate ? new Date(data.lastReviewDate) : undefined;

  return {
    lastReviewDate,
    isLoading,
    isError,
    refetch,
  };
};
